var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"native-warning-wrapper"},[(_vm.showed && !_vm.closed)?_c('div',{staticClass:"native-warning"},[_c('div',{staticClass:"warning-text"},[_vm._v("WARNING! TRACKING SERVICE IS NOT RESPONSIVE")]),_c('div',{staticClass:"warning-close",on:{"click":function($event){return _vm.close()}}},[_vm._v("⨯")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }